module.exports = __webpack_public_path__ + "img/building_services.0aaf6e9c.png";